export default __webpack_public_path__ + "static/Chart-1-Mobile-b7ae1c8bd63bd9a5a0cdd225c2d8c367.webp";